// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2oZ2W","header":"PatientBlock_header__3mBWW","label":"PatientBlock_label__1DGH7","option":"PatientBlock_option__3Egbu"};